import { createFbEventId } from '@/utils/fbqTrack'
import { useFbRuntimeConfig } from '@/composables/fbq/useFbRuntimeConfig'

declare function fbq(command: string, event: string, params?: object, options?: object): void

const DEDUP_STORAGE_KEY = 'fb_initiate_checkout_dedup'
const DEDUP_WINDOW_MS = 5 * 60 * 1000

function readDedupMap(): Record<string, number> {
  try {
    const raw = sessionStorage.getItem(DEDUP_STORAGE_KEY)
    if (!raw)
      return {}
    const parsed = JSON.parse(raw)
    return parsed && typeof parsed === 'object' ? parsed : {}
  }
  catch {
    return {}
  }
}

function writeDedupMap(map: Record<string, number>) {
  try {
    sessionStorage.setItem(DEDUP_STORAGE_KEY, JSON.stringify(map))
  }
  catch {}
}

export function useFbqInitiateCheckout() {
  const { isEventEnabled } = useFbRuntimeConfig()

  /**
   * 上报 InitiateCheckout 客户端事件，并返回 eventId 供后端 CAPI 双轨去重
   */
  function reportInitiateCheckout(params: {
    value: number
    currency: string
    contentIds: string[]
    numItems: number
    /** 是否启用 5 分钟同订单去重（订阅场景需要，金币充值不需要） */
    dedup?: boolean
  }): string | undefined {
    if (!isEventEnabled('INITIATE_CHECKOUT'))
      return undefined

    if (params.dedup) {
      const key = [...params.contentIds].sort().join('|')
      const now = Date.now()
      const map = readDedupMap()
      const last = map[key]
      if (last && now - last < DEDUP_WINDOW_MS)
        return undefined

      for (const k of Object.keys(map)) {
        if (now - map[k] >= DEDUP_WINDOW_MS)
          delete map[k]
      }
      map[key] = now
      writeDedupMap(map)
    }

    const eventId = createFbEventId('InitiateCheckout')
    if (typeof fbq !== 'undefined') {
      fbq('track', 'InitiateCheckout', {
        value: params.value,
        currency: params.currency,
        content_ids: params.contentIds,
        num_items: params.numItems,
      }, { eventID: eventId })
    }
    return eventId
  }

  return { reportInitiateCheckout }
}
